<section class="moments-section">
  <div class="section-header">
    <h2>Moments That Matter</h2>
    <p>
      Catch a glimpse of the program activities and students bonding through our recent events.
    </p>
  </div>
  <div class="moments-row">
    <div class="moments-grid">
      <div class="grid-item">
        <img src="img1.jpg" alt="Event 1">
      </div>
      <div class="grid-item">
        <img src="img2.jpg" alt="Event 2">
      </div>
      <div class="grid-item">
        <img src="img3.jpg" alt="Event 3">
      </div>
    </div>
  </div>

</section>